import React from 'react';
import Button from '../Button/Button';
import styles from './LinkAction.module.css';

interface LinkActionProps {
  label: string;
  icon?: string;
  iconSize?: number;
  onClick: () => void;
}

const LinkAction: React.FC<LinkActionProps> = ({
  label,
  icon = 'visibility',
  iconSize = 16,
  onClick,
}) => (
  <Button
    variant="link"
    size="xs"
    className={styles.link}
    onClick={onClick}
    icon={icon}
    iconSize={iconSize}
  >
    <span className={styles.label}>{label}</span>
  </Button>
);

export default LinkAction;
